// Parallel HubSpot Forms API submission for the Parts & Service form
// (id: parts-service, sections/parts-service.liquid). Kept as its own
// dedicated HubSpot form/script rather than folded into the Locations
// group (assets/locations-forms-hubspot.js) -- this form has genuinely
// extra fields (make/model/serial, issue description, purchase date)
// worth capturing on their own properties, and the requester wanted
// three separate groups: Locations, Parts & Service, and Knife
// Sharpening (assets/knife-sharpening-form-hubspot.js).
(function () {
  // Routed through the same-origin form relay (Shopify App Proxy ->
  // nella-app-proxy -> Linen Plus Middleware -> HubSpot), not a direct
  // client-side call to api.hsforms.com -- confirmed blocked by ad
  // blockers/tracking protection on a real visitor's browser. See
  // docs/testing/form-relay-strategy.html.
  const RELAY_URL = '/apps/nella-app-login/forms/parts_service';
  const FORM_TOKEN_URL = '/apps/nella-app-login/forms-token';

  const formEl = document.getElementById('parts-service');
  if (!formEl) return;
  if (formEl.dataset.hubspotWired) return;
  formEl.dataset.hubspotWired = 'true';

  // This form has one combined "Name" field -- same rationale and same
  // first-space split as every other HubSpot integration in this project.
  function splitName(fullName) {
    const trimmed = (fullName || '').trim().replace(/\s+/g, ' ');
    if (!trimmed) return { firstName: '', lastName: '' };
    const spaceIndex = trimmed.indexOf(' ');
    if (spaceIndex === -1) return { firstName: trimmed, lastName: '' };
    return { firstName: trimmed.slice(0, spaceIndex), lastName: trimmed.slice(spaceIndex + 1) };
  }

  function buildHubSpotFields() {
    const fields = [];
    const push = (name, value) => {
      const v = (value ?? '').toString().trim();
      if (v) fields.push({ name, value: v });
    };
    const byId = (id) => (document.getElementById(id)?.value || '').toString().trim();
    const { firstName, lastName } = splitName(byId('name'));

    push('email', byId('email'));
    push('firstname', firstName);
    push('lastname', lastName);
    push('phone', byId('phone'));
    push('company', byId('business-name'));
    push('address', byId('autocomplete')); // the address input's real id -- it's a Google Places Autocomplete field
    push('service_make_model_serial', byId('make_model_serial'));
    push('service_issue_description', byId('description_issue'));
    // <input type="date"> always yields "YYYY-MM-DD" -- sent as plain
    // text (not HubSpot's native Date property type) to avoid guessing
    // at the Forms API's exact expected date encoding (HubSpot Date
    // properties historically expect a UTC-midnight millisecond
    // timestamp for API submissions, not a plain date string -- rather
    // than risk a silently-rejected field, this uses a Single-line text
    // property that accepts the value exactly as typed).
    push('service_purchase_date', byId('date'));
    push('inquiry_source', 'Parts & Service');

    return fields;
  }

  // Fetched up front and refreshed periodically, not at submit time: this
  // native form navigates away immediately on submit (no preventDefault
  // below), which tears down this script's JS context before a token
  // fetched right then could reliably resolve -- `keepalive` only protects
  // an already-sent request, not a `.then()` waiting to send a second one
  // after it. A pre-fetched token keeps submit time down to that one
  // keepalive request.
  const FORM_TOKEN_REFRESH_MS = 5 * 60 * 1000; // server TTL is 10 min; refresh with margin
  let cachedFormToken = null;

  function fetchFormToken() {
    return fetch(FORM_TOKEN_URL)
      .then((r) => r.json())
      .then((data) => (data && data.token) || null)
      .catch(() => null);
  }

  function refreshFormToken() {
    fetchFormToken().then((token) => { cachedFormToken = token; });
  }

  refreshFormToken();
  setInterval(refreshFormToken, FORM_TOKEN_REFRESH_MS);

  function submitToHubSpot() {
    try {
      const payload = {
        fields: buildHubSpotFields(),
        pageUri: window.location.href,
        pageName: document.title,
      };
      fetch(RELAY_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ...payload, formToken: cachedFormToken }),
        keepalive: true,
      }).catch((err) => console.warn('HubSpot relay failed (Shopify submission is unaffected):', err));
    } catch (err) {
      console.warn('HubSpot relay failed (Shopify submission is unaffected):', err);
    }
  }

  formEl.addEventListener('submit', () => {
    submitToHubSpot();
  });
})();
